let SERVER = ''
let SERVER_V2 = ''
let name = ''

let facebook_id = "";
let zalo_id = "2313870396196688761";
let features = null;

switch (window.location.hostname) {
  case 'f2f.com.vn':
    SERVER = 'https://api.f2f.com.vn/API'
    SERVER_V2 = 'https://v2.f2f.com.vn/api'
    name = 'F2F'
    zalo_id= '1899050816951780246'
    features = {
      garden: true,
      store: true,
      tracking: true,
      find_land: true
    }
    break;

  case 'vietnamavocado.org':
    SERVER = 'https://api.vietnamavocado.org/API'
    name = 'VIETNAMAVOCADO'
    zalo_id= '1899050816951780246'
    features = {
      garden: true,
      store: false,
      tracking: false,
      find_land: false
    }
    break;
  case "farmlocal.com":
  case "localhost":
    SERVER = 'http://localhost:9000/API'
    SERVER_V2 = 'http://localhost:8000/api'
    name = 'LOCAL'

    features = {
      garden: true,
      store: true,
      tracking: true,
      find_land: true
    }
    break;
}

let role = {
  admin: 1,
  farmer: 2,
  system_user: 3,
  seller: 4
}
// https://farmbook.com/API/loginZalo
let callbackUrl = SERVER + '/loginZalo'
let precallbackUrl = SERVER + '/preloginZalo'


// https://oauth.zaloapp.com/v3/permission?app_id=2313870396196688761&redirect_uri={2}&state={3}

let ZALO_LOGIN_URL = 'https://oauth.zaloapp.com/v3/permission?app_id=' 
    + zalo_id + '&redirect_uri=' + encodeURIComponent(callbackUrl) + '&state=1'

function zaloUrl( type=null){
  let callbackUrlNew = callbackUrl;
  if ( type){
    callbackUrlNew +=  '?type='+type;
    // callbackUrlNew += '&email=' + email;
    // callbackUrlNew += '&phone=' + phone;
  }
  
  let url = 'https://oauth.zaloapp.com/v3/permission?app_id=' 
  + zalo_id + '&redirect_uri=' + encodeURIComponent(callbackUrlNew) + '&state=1';
  return url;
}

let apiKeyHereMap = '9ComSRXwJ8kxxSa1SMtEkPYCsX--3r2We93Q9rhZHGI';

export default {
  SERVER: SERVER,
  SERVER_V2: SERVER_V2,
  role: role,
  name: name,
  country_code: '+84',
  facebook_id:facebook_id,
  callbackUrl: callbackUrl,
  precallbackUrl:precallbackUrl,
  ZALO_LOGIN_URL: ZALO_LOGIN_URL,
  zaloUrl: zaloUrl,
  //FACEBOOK_KIT_URL: FACEBOOK_KIT_URL,
  features: features,
  apiKeyHereMap: apiKeyHereMap
}



// WEBPACK FOOTER //
// ./src/helpers/config.js